import { useMutation, useQuery } from '@tanstack/react-query';
import { usePWAContext } from '../../context/PWAContext';
import { getCredentials, saveCredentials, testCredentials } from './credentialsApi';

export const createCredentialsHooks = ({ queryClient }) => {
    const useGetCredentials = () =>
        useQuery({
            queryKey: ['credentials'],
            queryFn: getCredentials,
        });

    const useSaveCredentials = () => {
        let offlineQueue;
        let isOffline;
        try {
            const pwa = usePWAContext();
            offlineQueue = pwa?.offlineQueue;
            isOffline = pwa?.isOffline || false;
        } catch {
            offlineQueue = null;
            isOffline = false;
        }

        return useMutation({
            mutationFn: async (variables) => {
                if (isOffline && offlineQueue) {
                    const queued = offlineQueue.addToQueue({
                        url: '/api/credentials',
                        method: 'POST',
                        data: variables,
                    });
                    if (queued.queued) {
                        return { queued: true, message: 'Credentials save queued for offline sync' };
                    }
                }
                return saveCredentials(variables);
            },
            onSuccess: () => {
                queryClient.invalidateQueries({ queryKey: ['credentials'] });
            },
        });
    };

    const useTestCredentials = () =>
        useMutation({
            mutationFn: testCredentials,
        });

    return {
        useGetCredentials,
        useSaveCredentials,
        useTestCredentials,
    };
};
